import React from 'react'
import styled from 'styled-components'

const AlertContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  display: flex;
`
const ToolTipContainer = styled.span`
  display: flex;
`
const ToolTip = styled.div`
  font-family: 'Open Sans', sans-serif;
  background: #7f8284;
  color: white;
  display: none;
  ${ToolTipContainer}:hover & {
    display: block;
  }
  border-radius: 5px;
  padding: 10px;
  position: absolute;
  text-align: center;
  bottom: 37px;
  width: 190px;
  transform: translateX(-49%);
  left: 50%;
  &::after {
    position: absolute;
    bottom: -6px;
    content: '';
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #7f8284;
    left: 0;
    right: 0;
    margin: auto 0;
    left: calc(50% - 10px);
  }
`

export default ({ text, height, width, color, className }) => (
  <AlertContainer className={className}>
    <ToolTipContainer>
      <ToolTip>{text}</ToolTip>
      <svg width={width ? `${width}px` : '24px'}
        height={height ? `${height}px` : '23px'}
        viewBox="-1 -1 26 23"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
          <title>alert icon</title>
            <desc>Created with Sketch.</desc>
            <g id="alert-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="ico/warning/24">
                <g>
                  <path
                    stroke={color === 'orange' ? '#CC6900' : '#56565a'}
                    fill={color === 'orange' ? '#CC6900' : '#56565a'}
                    d="M12.9174497,0.655880661 C12.4128524,-0.215423036 11.5871476,-0.219989618 11.0825503,0.650400763 L0.21535885,19.4035232 C-0.289238474,20.2739136 0.123613882,21 1.13280853,21 L22.8671915,21 C23.8763861,21 24.2892385,20.2711736 23.7846411,19.4016966 L12.9174497,0.655880661 Z"
                    id="Fill-1"
                  />
                  <text id="!" fontFamily="OpenSans-Semibold, Open Sans" fontSize="14" fontWeight="500" fill="#FFFFFF">
                    <tspan x="10" y="17">!</tspan>
                  </text>
                </g>
              </g>
            </g>
      </svg>
    </ToolTipContainer>
  </AlertContainer>
)
